import React, { ReactNode } from 'react';
interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: ReactNode;
}
export function PageHeader({
  title,
  description,
  actions
}: PageHeaderProps) {
  return <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between" data-id="element-157" data-mp="15xx0b4q91w9a">
      <div data-id="element-158" data-mp="19yfqyvgeow9w">
        <h1 className="text-2xl font-semibold tracking-tight text-navy sm:text-[28px]" data-id="element-159" data-mp="19y7e33ka9qyp">
          {title}
        </h1>
        {description && <p className="mt-1.5 text-sm text-muted-foreground" data-id="element-160" data-mp="w5hh6437v1mt">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap gap-2" data-id="element-161" data-mp="1103vaf0on8al">{actions}</div>}
    </div>;
}